'use client'

import { Rating } from '../Rating'
import { Typography } from '../Typography'
import { TopBorderGrid } from './styles'

export interface ReviewBlockProps {
  general?: number
  programContent?: number
  facilityCustomerService?: number
  facilityEquipment?: number
  facilityCleanliness?: number
  count: number
}

const getValue = (value?: number) =>
  typeof value === 'number' ? value.toFixed(1) : '--'

export const ReviewBlock = ({
  general,
  programContent,
  facilityCustomerService,
  facilityEquipment,
  facilityCleanliness,
  count,
}: ReviewBlockProps) => {
  return (
    <div className="flex w-full flex-col items-center justify-center">
      <Typography variant="catch">{getValue(general)}</Typography>

      <Rating value={general ?? 0} totalCount={count} totalCountSuffix={'件'} />

      <TopBorderGrid columns={2}>
        <div className="flex items-center justify-between">
          <Typography variant="body2" color="gray.01">
            プログラム
          </Typography>
          <Typography variant="subhead2" color="gray.01">
            {getValue(programContent)}
          </Typography>
        </div>
        <div className="flex items-center justify-between">
          <Typography variant="body2" color="gray.01">
            設備・備品
          </Typography>
          <Typography variant="subhead2" color="gray.01">
            {getValue(facilityEquipment)}
          </Typography>
        </div>
        <div className="flex items-center justify-between">
          <Typography variant="body2" color="gray.01">
            受付・接客
          </Typography>
          <Typography variant="subhead2" color="gray.01">
            {getValue(facilityCustomerService)}
          </Typography>
        </div>
        <div className="flex items-center justify-between">
          <Typography variant="body2" color="gray.01">
            清潔感
          </Typography>
          <Typography variant="subhead2" color="gray.01">
            {getValue(facilityCleanliness)}
          </Typography>
        </div>
      </TopBorderGrid>
    </div>
  )
}
